import { useEffect, useState } from "react";
import { acceptAnalytics, declineAnalytics } from "../lib/consent";
import { enableAnalytics } from "../lib/firebase";

export default function CookieConsent() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    if (!localStorage.getItem("consent")) setShow(true);
  }, []);
  if (!show) return null;

  const accept = async () => {
    acceptAnalytics();
    await enableAnalytics();
    setShow(false);
  };
  const decline = () => {
    declineAnalytics();
    setShow(false);
  };

  return (
    <div className="fixed bottom-0 inset-x-0 z-50 bg-white border-t">
      <div className="mx-auto max-w-6xl px-4 py-4 flex flex-col md:flex-row gap-3 items-center justify-between">
        <p className="text-sm text-neutral-700">
          We use cookies for analytics to improve the site. No ads, no tracking beyond that.
        </p>
        <div className="flex gap-2">
          <button onClick={decline} className="border rounded px-4 py-2 text-sm">Decline</button>
          <button onClick={accept} className="border rounded px-4 py-2 text-sm">Accept</button>
        </div>
      </div>
    </div>
  );
}
